import { render, staticRenderFns } from "./GroupDeliveries.vue?vue&type=template&id=373a7934&scoped=true&"
import script from "./GroupDeliveries.vue?vue&type=script&lang=js&"
export * from "./GroupDeliveries.vue?vue&type=script&lang=js&"
import style0 from "./GroupDeliveries.vue?vue&type=style&index=0&id=373a7934&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373a7934",
  null
  
)

export default component.exports